import { createFileRoute } from '@tanstack/react-router';
import SectionListPage from '@/features/resume-builder/section-list';

/** Listagem de uma seção de lista (formacoes · experiencias · certificacoes-premios · ferramentas-idiomas). */
export const Route = createFileRoute('/perfil/curriculo/$section/')({
  component: SectionListPage,
});
